import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles({
    root: {
        alignSelf: "center",
        fontSize: "4em",
        color: '#999999'
    },
});

export default function ChartIcon() {
    const classes = useStyles();

    return (
        <SvgIcon viewBox="0 0 16 16" className={classes.root}>
            <title>Icon_Chart</title>
            <path d="M1.6,12H0V10.44H1.6ZM16,10.44H14.4V12H16ZM4,7.33H2.4V12H4Zm4.8,3.11H7.2V12H8.8Zm4.8-2.33H12V12h1.6ZM6.4,5H4.8v7H6.4Zm4.8,3.11H9.6V12h1.6Z" />
        </SvgIcon >
    );
}